import { Text, View } from '@react-pdf/renderer';

// Utils
import { hasValidCertification, isValidCertification } from '@shared/utils';
import { buildCertLine } from '@/utils/certification';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/AgilityIO/tokens';

// Types
import { FormCertification } from '@shared/types';

// Styles
import styles from '../style';
interface CertificatesSectionProps {
  certs: FormCertification[];
}
const CertificatesSection = ({
  certs
}: CertificatesSectionProps) => {
  if (!certs || !hasValidCertification(certs)) return null;
  const validCerts = certs.filter(isValidCertification);
  return <View style={styles.section} data-sentry-element="View" data-sentry-component="CertificatesSection" data-sentry-source-file="Certificates.tsx">
      <Text style={styles.sectionHeading} data-sentry-element="Text" data-sentry-source-file="Certificates.tsx">{SECTION_TITLES.certifications}</Text>

      {validCerts.map((cert, idx) => {
      const certLine = buildCertLine(cert?.name ?? '', cert?.issue);
      if (!certLine) return null;
      return <Text key={`cert-${idx}`} style={styles.entryLine}>
            {certLine}
          </Text>;
    })}
    </View>;
};
export default CertificatesSection;